import { put, select } from "@redux-saga/core/effects";
import { getMailchimpListsFailure, getMailchimpListSuccess } from "../actionCreators";
import { IntegrationService } from "../integration.service";

export function* getMailchimpListsSaga() {
    try {
        const formId: string = yield select(state => state.forms.current._id);
        const { data } = yield IntegrationService.getMailchimpLists(formId);
        yield put(getMailchimpListSuccess({ success: true, message: "", mailchimpData: data }));
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || "Failed to fetch Mailchimp Lists";
        yield put(getMailchimpListsFailure(errorMessage));
    }
}
